<template>
  <div class="step-container">
    <div class="number">
      <slot name="number" />
    </div>
    <div class="description">
      <div class="title">
        <slot name="title" />
      </div>
      <div class="time">
        <slot name="time" />
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: "Step"
};
</script>

<style scoped lang="scss">
.step-container {
  display: flex;
  flex-direction: row;
}

.number {
  width: 24px;
  height: 24px;
  line-height: 24px;

  border: 1px solid #2AA5E3;
  border-radius: 50%;
  text-align: center;

  font-size: 14px;
  color: #2AA5E3;
}

.description {
  margin-left: 13px;

  .title {
    font-size: 16px;
    color: #333333;
    height: 28px;
    line-height: 28px;
  }

  .time {
    font-size: 14px;
    color: #666666;
    margin-top: 8px;
  }

}

</style>
